import { jsx as _jsx } from "react/jsx-runtime";
import { ChevronRightIcon } from '@icons';
import classNames from 'classnames';
import React from 'react';
import { Button } from '../button/button';
import styles from './carousel.module.scss';
const CarouselButton = ({ onClick, position, hide, direction, focusable, label, size, }) => {
    return (_jsx("span", { className: classNames([
            styles.btn,
            position === 'left' ? styles.btn_left : styles.btn_right,
            direction === 'horizontal'
                ? styles.btn_horizontal
                : styles.btn_vertical,
        ], {
            [styles.btn_hide]: hide,
        }), children: _jsx(Button, { type: "icon", onClick: onClick, focusable: focusable, label: label, size: size, children: _jsx(ChevronRightIcon, {}) }) }));
};
CarouselButton.displayName = 'CarouselButton';
export { CarouselButton };
